export default __webpack_public_path__ + "static/media/powerserv_logo_2.5461fd8b.png";